/** A page whose code is still on its way (Lazy.svelte) tells the top bar here. */
class PageLoading {
  count = $state(0);

  start(): () => void {
    this.count += 1;
    let done = false;
    return () => {
      if (done) return;
      done = true;
      this.count -= 1;
    };
  }
}

export const pageLoading = new PageLoading();
